import { useState, useRef } from "react";
import axios from "axios";
import { toast } from "sonner";
import { QrCode, Camera, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { QRScanner } from "@/components/QRScanner";
import { parseVCard } from "@/lib/vcard";
import { compressImage } from "@/lib/image";
import { API } from "@/lib/api";

// onData riceve i campi anagrafici riconosciuti (formato buyer) e l'eventuale foto
export const CaptureButtons = ({ onData, photo }) => {
  const [showScanner, setShowScanner] = useState(false);
  const [ocrLoading, setOcrLoading] = useState(false);
  const fileRef = useRef(null);

  const handleQRResult = (text) => {
    setShowScanner(false);
    const filled = Object.fromEntries(Object.entries(parseVCard(text)).filter(([, v]) => v));
    const n = Object.keys(filled).length;
    if (n === 0) return toast.error("Nessun dato vCard riconosciuto nel QR");
    onData(filled);
    toast.success(`Dati importati dal QR (${n} campi)`);
  };

  const handlePhoto = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setOcrLoading(true);
    let dataUrl = null;
    try {
      dataUrl = await compressImage(file);
      onData({}, dataUrl);
      const res = await axios.post(`${API}/leads/ocr`, { image_base64: dataUrl });
      const filled = Object.fromEntries(Object.entries(res.data).filter(([, v]) => v));
      onData(filled, dataUrl);
      toast.success(`Biglietto analizzato (${Object.keys(filled).length} campi riconosciuti)`);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore durante l'analisi OCR");
    } finally {
      setOcrLoading(false);
    }
  };

  return (
    <div className="grid grid-cols-1 gap-3">
      {showScanner && (
        <QRScanner
          onResult={handleQRResult}
          onClose={(err) => {
            setShowScanner(false);
            if (err) toast.error(err);
          }}
        />
      )}
      <input ref={fileRef} type="file" accept="image/*" capture="environment" className="hidden" onChange={handlePhoto} data-testid="ocr-file-input" />
      <Button
        data-testid="scan-qr-btn"
        onClick={() => setShowScanner(true)}
        className="min-h-[64px] rounded-xl bg-buscema-green hover:bg-buscema-greenDark text-white text-base font-semibold gap-3 shadow-md"
      >
        <QrCode className="w-6 h-6" /> Scansiona QR / vCard
      </Button>
      <Button
        data-testid="scan-ocr-btn"
        onClick={() => fileRef.current?.click()}
        disabled={ocrLoading}
        variant="outline"
        className="min-h-[64px] rounded-xl border-2 border-buscema-gold text-buscema-gold hover:bg-buscema-gold hover:text-white text-base font-semibold gap-3 bg-white"
      >
        {ocrLoading ? <Loader2 className="w-6 h-6 animate-spin" /> : <Camera className="w-6 h-6" />}
        {ocrLoading ? "Analisi in corso..." : "Foto Biglietto da Visita (OCR)"}
      </Button>
      {photo && (
        <img src={photo} alt="Biglietto" className="rounded-xl border border-gray-200 max-h-40 object-contain bg-white" data-testid="card-photo-preview" />
      )}
    </div>
  );
};
